import React from "react";
import RenderSubSectionTitle from "./RenderSubSectionTitle";
import _ from "lodash";

function getFirstLine(fileEntity) {
  let firstLine = [];
  if (fileEntity.laterality) {
    if (fileEntity.laterality === "LEFT") {
      firstLine.push(<b>LE - </b>);
    } else if (fileEntity.laterality === "RIGHT") {
      firstLine.push(<b>RE - </b>);
    } else {
      firstLine.push(<b>BE - </b>);
    }
  }
  let from = fileEntity.fileFrom;

  if (from.includes("Wide")) {
    if (from.includes("Autofluoroscence")) {
      from = "Wide Field with Autofluoroscence (OPTOS)";
    } else {
      from = "Wide Field (OPTOS)";
    }
  }
  firstLine.push(<b>{from}</b>);

  return firstLine;
}

function getFilesEntityContent(fileEntity) {
  let files_content = [];
  if (fileEntity.notes) {
    files_content.push(fileEntity.notes);
  }
  _.forEach(fileEntity.data, (x) => {
    if (x.value) {
      files_content.push(`${x.key}: ${x.value}`);
    }
  });
  return files_content;
}

function FilesSection({ fileEntities, styleOptions }) {
  if (!fileEntities || !fileEntities.length) {
    return null;
  }
  return (
    <div style={styleOptions.mainContainerStyle}>
      <RenderSubSectionTitle text="Investigations and Procedures" />
      <div style={styleOptions.subSectionContainerStyle}>
        {fileEntities.map((fileEntity) => {
          let files_content = getFilesEntityContent(fileEntity);
          let first_line = getFirstLine(fileEntity);

          return (
            <div style={styleOptions.subSectionStyle}>
              <div>
                {first_line.map((fileEntity) => {
                  return <>{fileEntity}</>;
                })}
              </div>
              {files_content.map((fileEntity) => (
                <div>{fileEntity}</div>
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default FilesSection;
